

























































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Base } from '@/components/common/base';
import { PaginationModel, VAction, VHeaders } from '@/models/pagedlistmodel';
import {
  PartSaleShipment,
  getShipmentHeaders,
  IFilter,
  PartSaleCustomerModel,
  IEmailViewModel,
} from '@/models/fixedops/partsales';
import { MetadataType, MetadataKeyIdentifier } from '@/enums/enums';
import { DateTimeHelper } from '@/helper/date-time.helper';
import {partSalesService} from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    Datepicker: () => import('@/components/common/app.datepicker.vue'),
  },
})
export default class PartSalesShipmentPage extends Base {
  public showInvoiceDatePicker: boolean = false;
  public pagination = new PaginationModel('createdAt');
  public loading: boolean = false;
  public actions: VAction[] = [];
  public headers: VHeaders[] = getShipmentHeaders(this);
  public partSaleShipments: PartSaleShipment[] = [];
  public orderStatusDialog: boolean = false;
  public orderStatusLoading: boolean = false;
  public orderStatus: string = '';

  public filter: IFilter = {
    invoiceNumber: '',
    sortName: '',
    counterPersonId: '',
    transDate: '',
    isOpenPartSaleOrder: false,
  };
  public showSendEmailPopup: boolean = false;
  public showCallPopup: boolean = false;
  public showCustomerInfoPopup: boolean = false;
  public emailModel: IEmailViewModel = {};

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'search') {
      this.search();
    }
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public updateToolBar(): void {
    // let buttons: any = [];
    // buttons.push({'id':'0', 'type':'button', 'title':'Search', 'disabled':false, 'visible': true, 'class':'btn', 'label':'Search', 'click':'search', 'icon':'fas fa-search','requestProgress': true});
    // this.$emit('updateToolBar', buttons);
  }

  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'partSales');
    
    // toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    if (this.$route.params.invoiceNumber) {
      this.filter.invoiceNumber = this.$route.params.invoiceNumber;
    }
    this.getPartSales();
    this.setActions();
  }

  public setActions(): void {
    this.actions = [
      {
        type: 'button',
        icon: 'fa fa-map-marker',
        title: this.$parent.$t(
          'partSalesShipment.partSalesShipmentGrid.gridActions.view'
        ) as string,
        action: (model: PartSaleShipment) => {
          this.getOrderStatus(model);
        },
      },
    ];
  }

  public async getPartSales(): Promise<void> {
    try {
      this.loading = true;
      this.$emit('update:progress', this.loading);
      const partSaleShipments = await partSalesService.getAllShipmentAsync(
        this.pagination,
        this.filter
      );
      this.partSaleShipments = partSaleShipments.results;
      this.pagination.totalItems = partSaleShipments.total;
    } finally {
      this.loading = false;
      this.$emit('update:progress', this.loading);
    }
  }

  public async getShipToAddress(invoiceNumber: string): Promise<void> {
    try {
      this.loading = true;
      this.$emit('update:progress', this.loading);
      const resp = await partSalesService.getShipToAddressAsync(
        invoiceNumber
      );
    } finally {
      this.loading = false;
      this.$emit('update:progress', this.loading);
    }
  }

  public updatePaging(paging: PaginationModel): void {
    this.pagination = paging;
    this.getPartSales();
  }

  public search(): void {
    this.pagination.page = 1;
    this.getPartSales();
  }

  // emit fuction
  public setDateValuesPartSales(date: any): void {
    this.filter.transDate = date;
  }

  public async getOrderStatus(model: PartSaleShipment): Promise<void> {
    try {
      if (model.orderId) {
        this.orderStatusLoading = true;
        const resp = await partSalesService.getOrderStatus(model.orderId);
        if (resp.orderUrl) {
          window.open(resp.orderUrl, '_blank');
        } else {
          this.showAlert(false, 'Tracking url not found');
        }
      } else {
        this.showAlert(false, 'Order Id is empty');
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.orderStatusLoading = false;
    }
  }
}
